import { t } from "@lingui/macro";
import { ArrowLeftIcon, LockIcon, SidebarSimpleIcon } from "@phosphor-icons/react";
import { Button, Tooltip } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { useState } from "react";
import { useNavigate } from "react-router";

import { useBuilderStore } from "@/client/stores/builder";
import { useResumeStore } from "@/client/stores/resume";

export const BuilderHeader = () => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);

  const title = useResumeStore((state) => state.resume.title);
  const locked = useResumeStore((state) => state.resume.locked);

  const toggle = useBuilderStore((state) => state.toggle);
  const isDragging = useBuilderStore(
    (state) => state.panel.left.handle.isDragging || state.panel.right.handle.isDragging,
  );
  const leftPanelSize = useBuilderStore((state) => state.panel.left.size);
  const rightPanelSize = useBuilderStore((state) => state.panel.right.size);

  const onToggle = (side: "left" | "right") => {
    toggle(side);
  };

  const handleBack = () => {
    setIsSaving(true);
    setTimeout(() => {
      setIsSaving(false);
      navigate("/dashboard/resumes");
    }, 1500);
  };

  return (
    <>
      {isSaving && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/80 backdrop-blur-sm">
          <div className="flex flex-col items-center gap-4">
            <div className="size-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            <p className="text-lg font-medium">{t`Saving...`}</p>
          </div>
        </div>
      )}

      <div
        style={{ left: `${leftPanelSize}%`, right: `${rightPanelSize}%` }}
        className={cn(
          "fixed inset-x-0 top-0 z-[60] h-16 bg-secondary-accent/50 backdrop-blur-lg lg:z-20",
          !isDragging && "transition-[left,right]",
        )}
      >
        <div className="flex h-full items-center justify-between px-4">
          <Button
            size="icon"
            variant="ghost"
            className="flex lg:hidden"
            onClick={() => {
              onToggle("left");
            }}
          >
            <SidebarSimpleIcon />
          </Button>

          <div className="flex items-center justify-center gap-x-1 lg:mx-auto">
            <Tooltip content={t`Back to Dashboard`}>
              <Button size="icon" variant="ghost" onClick={handleBack}>
                <ArrowLeftIcon />
              </Button>
            </Tooltip>

            <span className="mr-2 text-xs opacity-40">{"/"}</span>

            <h1 className="font-medium">{title}</h1>

            {locked && (
              <Tooltip content={t`This resume is locked, please unlock to make further changes.`}>
                <LockIcon size={14} className="ml-2 opacity-75" />
              </Tooltip>
            )}
          </div>

          <Button
            size="icon"
            variant="ghost"
            className="flex lg:hidden"
            onClick={() => {
              onToggle("right");
            }}
          >
            <SidebarSimpleIcon className="-scale-x-100" />
          </Button>
        </div>
      </div>
    </>
  );
};
